import uuid from 'uuid-random';

import { addPopupAction, LAYER } from '@core/js/components/common/PopupManager';

import { AlreadySlotClubMemberPopup } from './AlreadySlotClubMemberPopup';

const popupId = uuid();

export const showRetailAlreadySlotClubMemberPopupAction = ({ userName }: { userName: string }) =>
    addPopupAction({
        id: popupId,
        component: AlreadySlotClubMemberPopup,
        layer: LAYER.LOGIN,
        userName
    });
